module.exports = __webpack_public_path__ + "static/media/14.ab710e5d.svg";